// ---- Theme tokens (CSS variables) — light only, opencode-inspired ----
// Warm white background, BLACK accent (inverted button: black bg, white text), hairline border.
export const THEME = {
  bg: '#ffffff',
  sidebar: '#ffffff',
  border: '#e8e8e0',
  text: '#1a1a1a',
  textMuted: '#6a6a72',
  textDim: '#9a9a90',
  accent: '#1a1a1a',          // opencode: button primary = solid black
  accentHover: '#000000',
  accentText: '#ffffff',
  success: '#16a34a',
  error: '#dc2626',
  canvasBg: '#ffffff',
  font: '"JetBrains Mono", "Berkeley Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  bodyFont: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

export function injectTheme(): void {
  document.getElementById('theme-vars')?.remove();
  const css = `
    :root {
      --bg: ${THEME.bg};
      --sidebar: ${THEME.sidebar};
      --border: ${THEME.border};
      --text: ${THEME.text};
      --text-muted: ${THEME.textMuted};
      --text-dim: ${THEME.textDim};
      --accent: ${THEME.accent};
      --accent-hover: ${THEME.accentHover};
      --accent-text: ${THEME.accentText};
      --success: ${THEME.success};
      --error: ${THEME.error};
      --canvas-bg: ${THEME.canvasBg};
      --app-font: ${THEME.bodyFont};
      --mono-font: ${THEME.font};
    }
    body { background: var(--bg); color: var(--text); font-family: var(--app-font); margin: 0; }
    h1, h2, h3 { font-family: var(--mono-font); letter-spacing: -0.02em; }
    code, pre, .mono { font-family: var(--mono-font); }
  `;
  const style = document.createElement('style');
  style.id = 'theme-vars';
  style.textContent = css;
  document.head.appendChild(style);
}

// ---- Theme switcher: removed in R15 (single theme) ----
// Stub so old main.ts still imports; render static label "Light".
export interface ThemeSwitcherHandle {
  el: HTMLElement;
  current: 'light';
  setOnChange: (cb: (t: 'light') => void) => void;
}
export function createThemeSwitcher(): ThemeSwitcherHandle {
  const el = document.createElement('div');
  el.textContent = '☀ Light';
  el.style.cssText = 'font-size:12px;color:var(--text-muted);padding:4px 0;';
  return { el, current: 'light', setOnChange: () => {} };
}



